import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

const iconMap: Record<string, string> = {
  shoes: 'ri-footprint-line',
  hoodies: 'ri-t-shirt-line',
  tshirts: 'ri-t-shirt-line',
  jackets: 'ri-star-line',
  pants: 'ri-ruler-line',
  headwear: 'ri-vip-crown-line',
  sets: 'ri-stack-line',
  underwear: 'ri-heart-line',
  jersey: 'ri-trophy-line',
  accessories: 'ri-sparkling-line',
  bags: 'ri-shopping-bag-line',
  belts: 'ri-links-line',
  perfumes: 'ri-drop-line',
  other: 'ri-more-fill',
};

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group flex flex-col rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300/60 overflow-hidden transition-all duration-300 cursor-pointer"
            title={`${t(cat.nameKey)} — YOYBUY Spreadsheet`}
          >
            <div className="w-full aspect-square overflow-hidden bg-background-100">
              <img
                src={cat.imageUrl}
                alt={t(cat.nameKey)}
                title={`${t(cat.nameKey)} — YOYBUY Spreadsheet`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="flex items-center gap-2 px-3 py-3">
              <div className="w-8 h-8 rounded-full bg-accent-100/80 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${iconMap[cat.id] || 'ri-store-line'} text-accent-600 group-hover:text-background-50 text-sm w-4 h-4 flex items-center justify-center`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-foreground-950 leading-tight whitespace-nowrap">
                {t(cat.nameKey)}
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}